import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class QualityMaintenanceScheduleService {
    static getQualityMaintenanceSchedules(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`quality-maintenance-schedules?filter=${qs}`, pageNumber));
    }
    static fetchQualityMaintenanceSchedule(oid) {
        return lastValueFrom(BaseService.get(`quality-maintenance-schedules/${oid}`));
    }
    static saveQualityMaintenanceSchedule(dto) {
        return lastValueFrom(BaseService.save(`quality-maintenance-schedules`, dto));
    }
    static deleteQualityMaintenanceSchedule(oid) {
        return lastValueFrom(BaseService.delete(`quality-maintenance-schedules/${oid}`));
    }
}
